"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataQualityDetailPermissionRequired = exports.DataQualityDetailMessageStyle = exports.dataQualityDetailMessageStyle = exports.DataQualityDetailDateStyle = exports.DataQualityDetailAuthorStyle = exports.DataQualityDetailAssetStyle = exports.DataQualityDetailStatusChipStyle = exports.DataQualityStatusChipIconClass = exports.DataQualityStatusChipIconOnlyClass = exports.DataQualityTooltipLabelClass = exports.DataQualityDetailStyle = exports.DataQualityDetailGroupSpacerDiv = exports.DataQualityDetailGroupDiv = exports.DataQualityDetailGroupHeadingDiv = exports.DataQualityDetailContentStyle = exports.DataQualityDetailPanelDialogBodyStyle = exports.DataQualityDetailPanelDialogStyle = exports.DataQualityStatusIconButtonStyle = exports.DataQualityStatusChipSevereButtonStyle = exports.DataQualityStatusChipButtonStyle = void 0;
var widgets_1 = require("@tableau/widgets");
var LayoutComponents_1 = require("./LayoutComponents");
var StyleConstants_1 = require("./StyleConstants");
var StyleFunctions_1 = require("./StyleFunctions");
var Typography = widgets_1.TabStyles.Typography;
var Spacing = widgets_1.TabStyles.Spacing;
var Sizing = widgets_1.TabStyles.Sizing;
exports.DataQualityStatusChipButtonStyle = {
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    color: StyleConstants_1.DataQualityStatusTitleColor,
    height: Sizing.RowHeight,
    fontSize: Typography.Sizing.Default,
    paddingLeft: Spacing.DefaultSpace,
    backgroundColor: StyleConstants_1.DataQualityStatusChipBackgroundColor,
};
exports.DataQualityStatusChipSevereButtonStyle = __assign(__assign({}, exports.DataQualityStatusChipButtonStyle), { color: StyleConstants_1.DataQualityStatusSevereTitleColor, backgroundColor: StyleConstants_1.DataQualityStatusChipSevereBackgroundColor });
exports.DataQualityStatusIconButtonStyle = {
    padding: Spacing.SmallSpace,
    cursor: 'pointer',
};
exports.DataQualityDetailPanelDialogStyle = {
    width: StyleConstants_1.DataQualityDetailPanelWidth,
    maxHeight: StyleConstants_1.DataQualityDetailPanelMaxHeight,
};
exports.DataQualityDetailPanelDialogBodyStyle = {
    paddingTop: Spacing.LargeSpace,
    paddingBottom: 0,
    // Set the maximum height of both the dialog and its body for IE11 compatibility.
    maxHeight: StyleConstants_1.DataQualityDetailPanelMaxHeight,
};
exports.DataQualityDetailContentStyle = __assign(__assign({}, exports.DataQualityDetailPanelDialogBodyStyle), { paddingLeft: Spacing.LargeSpace, paddingRight: Spacing.LargeSpace, overflow: 'auto' });
exports.DataQualityDetailGroupHeadingDiv = (0, LayoutComponents_1.divWithStyle)('DataQualityDetailGroupHeadingDiv', {
    fontWeight: 'bold',
    marginBottom: Spacing.LargeSpace,
});
exports.DataQualityDetailGroupDiv = (0, LayoutComponents_1.divWithStyle)('DataQualityDetailGroupDiv', {
    fontSize: Typography.Sizing.Default,
    paddingLeft: 9,
    width: 255,
});
exports.DataQualityDetailGroupSpacerDiv = (0, LayoutComponents_1.divWithStyle)('DataQualityDetailGroupSpacerDiv', {
    height: 9
});
exports.DataQualityDetailStyle = (0, LayoutComponents_1.divWithStyle)('DataQualityDetailDiv', {
    marginBottom: Spacing.LargeSpace,
});
exports.DataQualityTooltipLabelClass = (0, StyleFunctions_1.cssClass)('DataQualityTooltipLabelClass', {
    color: StyleConstants_1.DataQualityStatusTitleColor,
    paddingLeft: Spacing.DefaultSpace,
    paddingRight: Spacing.DefaultSpace,
});
exports.DataQualityStatusChipIconOnlyClass = (0, StyleFunctions_1.cssClass)('DataQualityStatusChipIconOnlyClass', {
    verticalAlign: 'text-bottom',
    alignContent: 'left'
});
exports.DataQualityStatusChipIconClass = (0, StyleFunctions_1.cssClass)('DataQualityStatusChipIconClass', {
    verticalAlign: 'text-bottom'
});
exports.DataQualityDetailStatusChipStyle = (0, LayoutComponents_1.divWithStyle)('DataQualityDetailStatusChip', {
    marginBottom: Spacing.MediumSpace
});
exports.DataQualityDetailAssetStyle = (0, LayoutComponents_1.divWithStyle)('DataQualityDetailAsset', {
    fontWeight: 'bold',
    color: Typography.Color.Primary,
    fontSize: Typography.Sizing.Default,
    marginTop: Spacing.DefaultSpace,
    marginBottom: Spacing.DefaultSpace,
    textOverflow: 'ellipsis',
    display: 'flex',
    whiteSpace: 'pre-wrap',
    overflow: 'hidden'
});
exports.DataQualityDetailAuthorStyle = (0, LayoutComponents_1.divWithStyle)('DataQualityDetailAuthor', {
    color: Typography.Color.Primary,
    fontSize: Typography.Sizing.Default,
    marginBottom: Spacing.DefaultSpace,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
});
exports.DataQualityDetailDateStyle = (0, LayoutComponents_1.divWithStyle)('DataQualityDetailDate', {
    color: Typography.Color.Secondary,
    fontSize: Typography.Sizing.Default,
    marginBottom: Spacing.DefaultSpace
});
exports.dataQualityDetailMessageStyle = {
    width: 255,
    color: Typography.Color.Primary,
    fontSize: Typography.Sizing.Default,
};
exports.DataQualityDetailMessageStyle = (0, LayoutComponents_1.divWithStyle)('DataQualityDetailMessage', {
    width: 255,
    color: Typography.Color.Primary,
    fontSize: Typography.Sizing.Default,
    $nest: {
        p: {
            marginTop: 0,
            marginBottom: 6, // TODO: 16?
        }
    }
});
exports.DataQualityDetailPermissionRequired = {
    color: 'rgba(0,0,0,0.56)',
};
//# sourceMappingURL=DataQualityStyles.js.map